<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav class="mr-2">
        <b-button size="sm" variant="primary" @click="onBack()">
          <font-awesome-icon icon="chevron-left"/>
          Назад
        </b-button>
      </b-navbar-nav>
      <b-navbar-nav class="mx-2">
        <template v-if="isBusy">
          <h4 class="mb-0" id="user-ellipsis-loading">Загрузка пользователя</h4>
        </template>
        <template v-else>
          <h4>{{ user.name === '' ? "Новый пользователь" : user.name }}</h4>
        </template>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-row align-v="center">
          <b-col cols="auto">
            <b-button size="sm" variant="success" :disabled="loading" @click="onSubmit()">
              <b-spinner v-if="loading" small></b-spinner>
              <font-awesome-icon icon="save" class="mr-1" />
              Сохранить
            </b-button>
          </b-col>
        </b-row>
      </b-navbar-nav>
    </b-navbar>

    <b-skeleton-wrapper  :loading="isBusy">
      <template #loading>
        <b-card no-body>
          <b-tabs card>
            <b-tab title="Учетные данные" disabled/>
            <b-tab title="Связи" disabled/>
          </b-tabs>
          <b-card-body border-variant="white">
            <b-row class="pl-4 pr-4 pt-4 pb-3">
              <b-col lg="6">
                <b-card bg-variant="light">
                  <b-row class="mb-2 mt-1">
                    <b-col>
                      <b-skeleton width="29%" height="24%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="45%"/>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <b-skeleton width="30%" height="24%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="45%"/>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-skeleton width="9%" height="17%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="31%" class="mb-2"/>
                      <b-skeleton width="86%" height="16%" class="mb-0"/>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-skeleton type="input" width="45%" height="72%"/>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <b-col lg="6">
                <b-card bg-variant="light">
                  <b-row class="mt-1">
                    <b-col>
                      <b-skeleton width="8%" height="17%" class="mb-2"/>
                      <b-skeleton type="input" width="100%" height="30%" class="mb-2"/>
                      <b-skeleton width="21%" height="16%" class="mb-0"/>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-skeleton type="input" width="59%" height="45%" class="mb-0"/>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </template>

      <template #default>
        <b-card no-body>
          <b-tabs card>
            <b-tab title="Учетные данные" active>
              <b-card-body>
                <b-row>
                  <b-col lg="6">
                    <b-card bg-variant="light">
                      <b-form-group
                        id="group-name"
                        label="Имя пользователя"
                        :invalid-feedback="nameInvalidFeedback"
                        :state="nameState"
                      >
                        <b-form-input
                          type="text"
                          size="sm"
                          v-model="user.name"
                          :state="nameState"
                          trim>
                        </b-form-input>
                      </b-form-group>
                      <b-form-group
                        id="group-email"
                        label="Email пользователя"
                        :invalid-feedback="emailInvalidFeedback"
                        :state="emailState"
                      >
                        <b-form-input
                          type="text"
                          size="sm"
                          v-model="user.email"
                          :state="emailState"
                          trim>
                        </b-form-input>
                      </b-form-group>
                      <b-form-group
                        id="group-username"
                        label="Логин"
                        description="Придумайте Логин. Будет использоваться для входа в систему"
                        :invalid-feedback="userNameInvalidFeedback"
                        :state="userNameState"
                      >
                        <b-form-input
                          type="text"
                          size="sm"
                          v-model="user.username"
                          :state="userNameState"
                          trim>
                        </b-form-input>
                      </b-form-group>

                      <div v-if="isEdit">
                        <b-button size="sm" variant="info" @click.stop="onPasswordReset">Сгенерировать новый пароль</b-button>
                        <strong class="ml-2">{{password}}</strong>
                        <b-form-text v-if="password.length > 0">Не забудьте скопировать пароль. Далее нажмите Сбросить пароль</b-form-text>
                        <b-button class="mt-2" size="sm" v-if="password.length > 0" variant="danger" @click.stop="onChangePassword">Сбросить пароль</b-button>
                      </div>

                      <b-form-group
                        id="group-password"
                        label="Пароль"
                        description="Придумайте Пароль на Английском, минимум 6 символов. Будет использоваться для входа в систему"
                        :invalid-feedback="passwordInvalidFeedback"
                        :state="passwordState"
                        v-if="!isEdit"
                      >
                        <b-input-group>
                          <b-form-input
                            type="text"
                            size="sm"
                            v-model="password"
                            :state="passwordState"
                            trim>
                          </b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="info" @click.stop="onPasswordReset">Сгенерировать новый</b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>

                      <b-form-checkbox class="mt-2" v-model="user.active">Пользователь активен/не активен</b-form-checkbox>
                    </b-card>
                  </b-col>
                  <b-col lg="6">
                  </b-col>
                </b-row>
              </b-card-body>
            </b-tab>
            <b-tab title="Права доступа">
              <b-row>
                <b-col lg="6" md="12">
                  <b-card bg-variant="light">
                    <b-form-group id="group-role" label="Роль">
                      <b-form-select
                        size="sm"
                        v-model="user.role"
                        @change="onSelectRole"
                      >
                        <option v-for="option in roles" :value="option.code">
                          {{ option.name }}
                        </option>
                      </b-form-select>
                    </b-form-group>

                    <p>Разрешения</p>
                    <b-list-group bg-variant="light" class="text-small">
                      <PermissionListItem v-for="(item, index) in treeData" :key="index" :item="item" :tree-data="treeData"/>
                    </b-list-group>
                  </b-card>
                </b-col>
                <b-col lg="6" md="12">

                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Связи">
              <b-row>
                <b-col lg="6" md="12">
                  <b-list-group size="sm">
                    <b-list-group-item
                      class="d-flex justify-content-between align-items-center"
                      :variant="getStaffVariant()"
                    >
                      Штатный сотрудник
                      <div>
                        <staff-select ref="staff_select" v-on:onSelect="updateStaffId"></staff-select>
                      </div>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-card>
      </template>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
import users from "../../network/users";
import roles from "../../network/roles";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
    import UserRewards from "./UserRewards";
    import StaffSelect from "../Staff/StaffSelect";
    import PermissionListItem from "../Users/PermissionListItem"

export default {
  components: { UserRewards, StaffSelect, PermissionListItem },
  mixins: [
    users, roles,
    dateFormatter, helpers
  ],
  name: "UserAdd",
  props: ['user_id'],
  data() {
    return {
      title: 'Профиль',
      apiUrl : 'users',
      isBusy: false,
      loading: false,
      user: {
        id: 0,
        username: '',
        password: '',
        name: '',
        email: '',
        role: 'manager',
        role_name: 'Менеджер',
        rate: 0,
        rate_tax: 0,
        active: true,
        staff_id: null,
        permissions: [],
      },
      isEdit: false,
      roles: [],
      password: '',
      permissions: [],
      treeData: []
    }
  },
  async created() {
    await this.configureView(this.$props.user_id);
    this.roles = (await this. getUserRoles({})).data.items;
  },
  methods: {
    async configureView(user_id) {
      if (user_id) {
        await this.getUser(user_id);
        this.isEdit = true;
      } else {
        this.onPasswordReset();
      }

      await this.getPermissionsHandler();
    },
    async getUser(userId) {
      this.isBusy = true;
      this.loading = true;
      const result = await this.getUserById(userId);

      if (result && result.data) {
        this.isBusy = false;
        this.loading = false;
        this.user = result.data;

        this.$nextTick(async () => {
          if (this.$refs.staff_select && this.user.staff_id) {
            await this.$refs.staff_select.configure(this.user.staff_id);
          }
        });
      } else {
        this.isBusy = false;
        this.loading = false;
      }
    },
    async onSubmit() {
      this.loading = true;
      const isStaffValid = this.updateStaffId();

      if (!isStaffValid) {
        this.loading = false;
        return;
      }

      if (this.isEmpty(this.user.name)) {
        this.showSubmitError("Укажите имя пользователя.");
        this.loading = false;
        return;
      }

      if (this.isEmpty(this.user.username)) {
        this.showSubmitError("Укажите логин пользователя.");
        this.loading = false;
        return;
      }

      if (!this.validateEmail(this.user.email)) {
        this.showSubmitError("Укажите правильную почту пользователя.");
        this.loading = false;
        return;
      }

      this.updateUserPermissions();

      this.user.password = this.password
      const data = { ...this.user };

      const method = (data.id > 0) ? this.putUser : this.postUser;
      const result = await method(data);

      if (result.status === 422) {
        this.showSubmitError("Пользователь с таким логином уже существует. Найдите его в базе или введите другой логин.");
        this.loading = false;
        return;
      }

      if (!result || !result.data) {
        this.showError("Не удалось сохранить данные.");
        this.loading = false;
        return;
      }

      this.$router.push({
        name: 'Users',
        query: this.$route.query,
        hash: this.$route.hash
      }).catch(()=>{});

      this.loading = false;
    },
    onBack() {
      window.history.length > 1  ? this.$router.go(-1) : this.$router.push('/').catch(()=>{});
    },
    onPasswordReset() {
      this.password = Math.random().toString(36).slice(-8);
    },
    async onChangePassword() {
      const data = {
        id: this.user.id,
        password: this.password
      }
      const result = await this.postUserPassword(data);

      if (!result || !result.data) {
        this.showError("Не удалось сохранить данные.");
        this.loading = false;
        return;
      }

      this.password = '';
      this.showChangePasswordMessage();
    },
    showChangePasswordMessage() {
      this.$bvModal.msgBoxOk('Пароль обновлён');
    },
    updateStaffId() {
      if (this.$refs.staff_select != null) {
        if (this.$refs.staff_select.item == null) {
          this.user.staff_id = null;
          return true;
        }

        const selectedStaff = this.$refs.staff_select.item;

        if (selectedStaff.user_id != null) {
          const isSelf = this.user.id > 0 && selectedStaff.user_id === this.user.id;

          if (!isSelf) {
            this.showError("Сотрудник уже связан с другим Пользователем.");
            this.user.staff_id = null;
            this.$refs.staff_select.onClear();
            return false;
          }
        }

        this.user.staff_id = selectedStaff.id;
        return true;
      }
    },
    getStaffVariant() {
      return this.user.staff_id != null ? 'success' : 'default';
    },
    // Permissions
    async getPermissionsHandler() {
      const result = await this.getPermissions();
      if (result.data != null) {
        this.permissions = result.data.items.map(function (item) {
          item._checked = this.user.permissions.some(perm => perm === item.code);
          return item;
        }.bind(this));
      } else {
        this.permissions = [];
      }

      this.treeData = this.arrayToTree(this.permissions);
    },
    updateUserPermissions() {
      const permArray = this.treeToArray(this.treeData);
      const filteredPerm = permArray.filter(perm => perm.checked || perm.indeterminate);
      this.user.permissions = filteredPerm.map(perm => perm.code);
    },
    arrayToTree(items, rootCode = null) {
      const lookup = {};
      items.forEach(item => {
        lookup[item.code] = {
          ...item,
          children: [],
          _selected: item._checked,
          _computedChecked: false,
          _computedIndeterminate: false
        };
      });

      const tree = [];
      items.forEach(item => {
        if (item.parent_code === rootCode) {
          tree.push(lookup[item.code]);
        } else {
          const parent = lookup[item.parent_code];
          if (parent) {
            parent.children.push(lookup[item.code]);
          }
        }
      });

      // Фаза 3: Рекурсивный расчет снизу вверх
      const computeNodeState = (node) => {
        if (!node.children || node.children.length === 0) {
          // Лист
          if (node._selected) {
            node._computedChecked = true;
            node._computedIndeterminate = false;
          } else {
            node._computedChecked = false;
            node._computedIndeterminate = false;
          }
          return { checked: node._computedChecked, indeterminate: node._computedIndeterminate };
        }

        // Обрабатываем детей
        let childCheckedCount = 0;
        let childIndeterminateCount = 0;

        node.children.forEach(child => {
          const state = computeNodeState(child);
          if (state.checked) childCheckedCount++;
          if (state.indeterminate) childIndeterminateCount++;
        });

        const allChildrenChecked = childCheckedCount === node.children.length;
        const someChildrenSelected = childCheckedCount > 0 || childIndeterminateCount > 0;

        // Правила определения состояния:
        // 1. Если узел в selectedSet, он должен быть либо checked, либо indeterminate
        // 2. Если все дети checked, узел должен быть checked
        // 3. Если некоторые дети selected (checked или indeterminate), узел должен быть indeterminate
        // 4. Иначе узел не выбран

        if (node._selected) {
          // Узел явно в selectedCodes
          if (allChildrenChecked) {
            node._computedChecked = true;
            node._computedIndeterminate = false;
          } else {
            // Если не все дети выбраны, но узел в selectedCodes,
            // значит он должен быть indeterminate
            node._computedChecked = false;
            node._computedIndeterminate = true;
          }
        } else {
          // Узел не в selectedCodes
          if (allChildrenChecked) {
            node._computedChecked = true;
            node._computedIndeterminate = false;
          } else if (someChildrenSelected) {
            node._computedChecked = false;
            node._computedIndeterminate = true;
          } else {
            node._computedChecked = false;
            node._computedIndeterminate = false;
          }
        }

        return {
          checked: node._computedChecked,
          indeterminate: node._computedIndeterminate
        };
      };

      // Фаза 4: Применение вычисленных состояний
      const applyComputedStates = (node) => {
        node.checked = node._computedChecked;
        node.indeterminate = node._computedIndeterminate;

        delete node._selected;
        delete node._computedChecked;
        delete node._computedIndeterminate;

        if (node.children && node.children.length > 0) {
          node.children.forEach(child => applyComputedStates(child));
        }
      };

      // Выполняем расчеты
      tree.forEach(root => computeNodeState(root));
      tree.forEach(root => applyComputedStates(root));

      return tree;
    },
    // Функция преобразования дерева в массив
    treeToArray(nodes, parentCode = null) {
      const result = [];

      nodes.forEach(node => {
        result.push({
          code: node.code,
          name: node.name,
          parent_code: parentCode,
          checked: node.checked,
          indeterminate: node.indeterminate
        });

        if (node.children && node.children.length > 0) {
          result.push(...this.treeToArray(node.children, node.code));
        }
      });

      return result;
    },
    async onSelectRole(v) {
      const findRole = this.roles.find(r => r.code === v);

      if (!findRole) return;

      const result = await this.getUserRoleById(findRole.id);

      if (!result || !result.data) return;

      const role = result.data;
      this.user.permissions = role.permissions;
      await this.getPermissionsHandler();
    }
  },
  computed: {
    nameState() {
      return this.user.name.length >= 6;
    },
    nameInvalidFeedback() {
      return 'Минимум 6 символов';
    },
    emailState() {
      return this.user.email.length >= 6;
    },
    emailInvalidFeedback() {
      return 'Минимум 6 символов';
    },
    userNameState() {
      return this.user.username.length >= 5;
    },
    userNameInvalidFeedback() {
      return 'Минимум 5 символов';
    },
    passwordState() {
      return this.password.length >= 6
    },
    passwordInvalidFeedback() {
      return 'Минимум 6 Английских символов';
    },
  },
}
</script>

<style>
#user-ellipsis-loading {
  white-space: nowrap;
  display: inline-block;
}

@keyframes blink {
  0% { content: "."; }
  33% { content: ".."; }
  66% { content: "..."; }
  100% { content: "."; }
}

#user-ellipsis-loading::after {
  content: ".";
  animation: blink 1.5s infinite step-start;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/User.vue